import React from 'react'
import EyefinitySectionFields from '../EyefinitySectionFields'

export default function Prescription(props) {
  return <EyefinitySectionFields {...props} sectionName="prescription" title="Prescription" />
}
